"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Jul 20 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of {@link PriceCodeSettings price code settings}.
 *
 * @author Radek Beran
 */


var PriceCodeSettingsConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceCodeSettingsConverter, _DataObjectConverter_);

  function PriceCodeSettingsConverter() {
    _classCallCheck(this, PriceCodeSettingsConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceCodeSettingsConverter).apply(this, arguments));
  }

  return PriceCodeSettingsConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceCodeSettingsConverter = PriceCodeSettingsConverter;